import { render, staticRenderFns } from "./signTable.vue?vue&type=template&id=1bf03028&scoped=true&"
import script from "./signTable.vue?vue&type=script&lang=js&"
export * from "./signTable.vue?vue&type=script&lang=js&"
import style0 from "./signTable.vue?vue&type=style&index=0&id=1bf03028&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf03028",
  null
  
)

export default component.exports